import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";

export default function AdvertiserPlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/advertiser/plans").then((r) => setPlans(r.data)).catch(() => setPlans([])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="advertiser-plans">
      <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">AI plans</div>
      <h1 className="mt-3 font-serif-display text-4xl text-[var(--ink)]">Plans you&apos;ve generated · {plans.length}</h1>

      {loading ? <div className="mt-8 text-[var(--slate-2)]">Loading…</div> : plans.length === 0 ? (
        <div className="mt-10 surface p-12 text-center">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--gold)]">Empty</div>
          <div className="mt-3 font-serif text-3xl">No plans yet.</div>
          <Link to="/ai-planner" className="mt-6 inline-flex btn-primary">Generate a plan</Link>
        </div>
      ) : (
        <div className="mt-10 space-y-3">
          {plans.map((p) => (
            <div key={p.id} className="surface p-6">
              <button onClick={() => setOpen(open === p.id ? null : p.id)} className="w-full text-left flex items-center justify-between gap-4">
                <div>
                  <div className="font-serif text-xl text-[var(--ink)]">{p.plan?.headline || "Unnamed plan"}</div>
                  <div className="text-xs text-[var(--slate-2)] mt-1">
                    {p.request?.industry} · {p.request?.objective} · {formatINR(p.request?.budget_inr || 0)} · {p.request?.duration_weeks}w
                  </div>
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--gold)]">{new Date(p.created_at).toLocaleDateString()}</div>
              </button>
              {open === p.id && (
                <pre className="mt-4 text-xs text-[var(--slate-1)] bg-[var(--bone-warm)] p-4 overflow-auto max-h-96 font-mono">{JSON.stringify(p.plan, null, 2)}</pre>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
